import { render, staticRenderFns } from "./PagesTextWidget.vue?vue&type=template&id=6da77f10&"
import script from "./PagesTextWidget.vue?vue&type=script&lang=js&"
export * from "./PagesTextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports